<template>
    <div class="modal fade" :id="unique" tabindex="-1" role="dialog" :aria-labelledby="`${unique}-title`"
         aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" role="document"
             :class="`modal-${size}`"
        >
            <div class="modal-content"
                 v-bind:style="{ height: screenHeight ? '92vh': '' }"
            >
                <div class="modal-header">

                  <div class="form-inline">
                    <div class="form-group mb-2 ">
                      <h5 class="modal-title font-weight-bolder mr-3" :id="`${unique}-title`">
                        {{ title }}
                      </h5>
                    </div>
                    <div class="form-group mx-sm-3 mt-2 mb-2">
                      <slot name="heading"></slot>
                    </div>

                  </div>

<!--                    <h5 class="modal-title font-weight-bolder mr-3" :id="`${unique}-title`">-->
<!--                        {{ title }}-->
<!--                    </h5>-->
<!--                    <slot name="heading"></slot>-->
<!--                    <div class="ml-auto">-->
<!--                    </div>-->
                    <button type="button" :id="`close-${unique}`" class="close close_mod"
                            @click="closeModal"
                    >
<!--                                data-dismiss="modal" aria-label="Close"-->
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>


                <div class="modal-body text-small">
                    <slot></slot>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CmsModal2",
    emits: ["closedModal"],

    props: {
        unique: {
            type: String,
            default() {
                return '';
            }
        },
        title: {
            type: String,
            default() {
                return '';
            }
        },
        size: {
            type: String,
            default() {
                return '';
            }
        },
        screenHeight: {
            type: Boolean,
            default() {
                return false;
            }
        },

    },

    methods: {
        closeModal() {
            $(`#${this.unique}`).modal('hide');
            this.$emit("closedModal");
        }
    }
}
</script>

<style scoped>
.close_mod {
  color: #9c4747
}
</style>
